import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { EnvironmentService } from '../../../core/environment/environment.service';
import { SessionService } from '@app/core/session/session.service';

@Component({
  selector: 'app-context-button',
  templateUrl: './context-button.component.html',
  styleUrls: ['./context-button.component.css']
})
export class ContextButtonComponent implements OnInit {

  currentContext : number;
  contexts: Array<string>;

  constructor(private environmentService: EnvironmentService, private translate: TranslateService, @Inject('Window') private _window : Window, private sessionService: SessionService) { }

  ngOnInit() {
    this.currentContext = 0;
  }

  onClickChangeContext(i) {

    this.currentContext = i;

    if(this.currentContext == 1) {
      this.sessionService.updateSession().subscribe(() => {});
      let url = this.environmentService.envModel.appSettings.fundsLiabilitiesUrl;
      this._window.open(url, "Passivo de Fundos", 'width=800,height=600')
    }
  }
}
